module.exports = __webpack_public_path__ + "static/media/cert_74.047ebfda.jpg";